"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.CreditsConsumer = exports["default"] = void 0;

var _react = require("react"),
    context = (0, _react.createContext)({
  state: {},
  actions: {}
}),
    _default = context;

exports["default"] = _default;
var CreditsConsumer = context.Consumer;
exports.CreditsConsumer = CreditsConsumer;